import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useGlobalContext } from "../../ContextApi/GlobalContext";

const tabs = [
  { link: "/dashboard", title: "Dashboard", icon: "dashboard", label: "Home" },
  { link: "/users", title: "Users", icon: "group", label: "Users" },
  { link: "/queries", title: "Queries", icon: "question_answer", label: "Inbox" },
  {
    link: "/support",
    title: "Tickets",
    icon: "confirmation_number",
    label: "Tickets",
  },
];

const MobileBottomNav = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { dispatch } = useGlobalContext();

  const handleTab = (link, title) => {
    dispatch({ pageLink: link, pageName: title, sideBar: false });
    navigate(link);
  };

  const isActive = (link) => {
    if (link === "/dashboard") return location.pathname === "/dashboard";
    return location.pathname === link || location.pathname.startsWith(link);
  };

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-[900] lg:hidden bg-white/95 backdrop-blur-xl border-t border-slate-200 shadow-[0_-8px_30px_rgba(11,28,45,0.08)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="h-16 px-1 flex items-stretch justify-around">
        {tabs.map((tab) => {
          const active = isActive(tab.link);
          return (
            <button
              key={tab.link}
              type="button"
              onClick={() => handleTab(tab.link, tab.title)}
              className={`relative flex-1 flex flex-col items-center justify-center gap-0.5 transition-colors ${
                active ? "text-[#E63946]" : "text-slate-400"
              }`}
            >
              {active && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 rounded-full bg-[#E63946]" />
              )}
              <span
                className={`material-symbols-outlined text-[22px] transition-transform ${
                  active ? "scale-110" : ""
                }`}
                style={active ? { fontVariationSettings: "'FILL' 1" } : undefined}
              >
                {tab.icon}
              </span>
              <span
                className={`text-[9px] font-bold uppercase tracking-wider ${
                  active ? "text-[#0B1C2D]" : ""
                }`}
              >
                {tab.label}
              </span>
            </button>
          );
        })}

        <button
          type="button"
          onClick={() => dispatch({ sideBar: true })}
          className="flex-1 flex flex-col items-center justify-center gap-0.5 text-slate-400 active:text-[#0B1C2D] transition-colors"
        >
          <span className="material-symbols-outlined text-[22px]">apps</span>
          <span className="text-[9px] font-bold uppercase tracking-wider">
            More
          </span>
        </button>
      </div>
    </nav>
  );
};

export default MobileBottomNav;
